// src/pages/QuizPage/components/QuestionDots.tsx
import { useRef, useEffect } from "react";
import type { Question } from "../utils/quizTypes";

interface QuestionDotsProps {
  questions: Question[];
  current: number;
  answered: Record<number, number>;
  onSelect: (index: number) => void;
}

export default function QuestionDots({
  questions,
  current,
  answered,
  onSelect,
}: QuestionDotsProps) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const activeRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    activeRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });
  }, [current]);

  return (
    <div className="w-full border-t border-white/10 bg-black/20 shrink-0">
      <div
        ref={scrollRef}
        className="flex flex-nowrap lg:flex-wrap gap-1.5 overflow-x-auto lg:overflow-visible lg:justify-center px-4 py-3"
        style={{ scrollbarWidth: "none" }}>
        {questions.map((_, i) => {
          const isAns = answered[i] !== undefined;
          const isOk =
            isAns && questions[i]?.correct_answer_index === answered[i];
          return (
            <button
              key={i}
              ref={i === current ? activeRef : null}
              onClick={() => onSelect(i)}
              className={`w-8 h-8 shrink-0 rounded-lg text-xs font-black border transition-all ${
                i === current ?
                  "bg-blue-600 border-blue-500 shadow-lg shadow-blue-500/25"
                : isAns ?
                  isOk ?
                    "bg-green-500/20 border-green-500/40 text-green-300"
                  : "bg-red-500/20 border-red-500/40 text-red-300"
                : "bg-white/[0.04] border-white/10 text-white/40"
              }`}>
              {i + 1}
            </button>
          );
        })}
      </div>
    </div>
  );
}
